<template>
  <form class="text-xs leading-normal" novalidate @submit.prevent="submit">
    <input v-model="email" placeholder="email" required /><br />
    <input
      v-model="password"
      placeholder="password"
      type="password"
      required
    /><br />
    <button type="submit">{{ loggedIn ? 'log out' : 'login' }}</button>
    <window v-for="(err, i) in errors" :key="`err-${i}`" @close="winClose(i)">
      <img
        src="@/assets/images/ahahah.gif"
        alt="ah ah ah"
        width="320"
        height="248"
        class="block max-w-full h-auto"
      />
    </window>
    <audio class="hidden" ref="errorSound" preload>
      <source src="@/assets/audio/ahahah.mp3" type="audio/mpeg" />
    </audio>
  </form>
</template>

<script>
import uniqid from 'uniqid'
import Window from '@/components/Window.vue'
import mutation from '@/graphql/mutations/login.gql'

export default {
  name: 'Login',

  components: {
    Window
  },

  props: {
    loggedIn: {
      default: null,
      type: [Boolean, String]
    }
  },

  data: () => ({
    email: null,
    password: null,
    attemptedPassword: null,
    errors: []
  }),

  apollo: {
    $client: 'admin'
  },

  methods: {
    async submit() {
      if (this.loggedIn) {
        this.$bus.$emit('login', null)
      }
      if (this.password === this.attemptedPassword) {
        this.error()
        return
      }
      const variables = {
        email: this.email,
        password: this.password
      }
      let token
      try {
        token = await this.$apollo
          .mutate({ mutation, variables })
          .then(({ data }) => data && data.login)
          .catch(e => {
            const errs = e.graphQLErrors.map(x => x.message)
            throw new Error(errs)
          })
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
        this.error()
      }
      if (token) {
        this.$bus.$emit('login', token)
      }
    },

    error() {
      const id = uniqid()
      const errs = this.errors
      const sound = this.$refs.errorSound
      this.attemptedPassword = this.password
      errs.push(id)
      setTimeout(() => {
        const index = errs.indexOf(id)
        if (index !== -1) {
          errs.splice(index, 1)
        }
      }, 3000)
      sound.pause()
      sound.currentTime = 0
      sound.play()
    },

    winClose(index) {
      this.errors.splice(index, 1)
      this.$refs.errorSound.pause()
    }
  }
}
</script>
